import { connect } from "react-redux";

import {
	getQuestionMatches,
	changeImportantQuestion,
} from "ducks/discovery";

import { SECTIONS } from "apps/discovery/util/consts";

import ImportantQuestions from "apps/discovery/components/headers/ImportantQuestions";

function mapStateToProps(state) {
	const { discovery } = state;

	let currentPage = 0;

	if (
		discovery.sections &&
		discovery.sections[SECTIONS.important_questions] &&
		discovery.sections[SECTIONS.important_questions].header_component
	) {
		currentPage = discovery.sections[SECTIONS.important_questions].header_component.currentPage;
	}

	return {
		currentPage,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		getQuestionMatches(section, params) {
			dispatch(getQuestionMatches(section, params));
		},

		changeImportantQuestion(params) {
			dispatch(changeImportantQuestion(params));
		},
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ImportantQuestions);



// WEBPACK FOOTER //
// ./src/apps/discovery/containers/headers/ImportantQuestions.jsx